import { FinancialModelCardLabel } from "@/feature/financial-model/constants"
import {
  FinancialModelSettings,
  FinancialModelSettingsV2Response,
  FinancialModelSettingsV2Model,
  ParsedSingleFinancialModelSettingsV2,
} from "./types"

export const groupSettingsByStep = (
  settings: FinancialModelSettings[]
): Record<number, FinancialModelSettings[]> =>
  settings.reduce(
    (acc, curr) => {
      if (!acc[curr.step]) {
        acc[curr.step] = []
      }
      acc[curr.step].push(curr)
      return acc
    },
    {} as Record<number, FinancialModelSettings[]>
  )

export const parseFinancialModelSettingsV2 = (
  data: FinancialModelSettingsV2Response,
  module: FinancialModelSettingsV2Model
): ParsedSingleFinancialModelSettingsV2 => {
  const item = data[module]
  if (!item) {
    throw new Error(`Item not found`)
  }
  return {
    completion_status: Number(item.completion_status),
    settings: groupSettingsByStep(item.settings),
  }
}

export function mergeSettingsToPolicies<
  T extends Record<string, FinancialModelCardLabel>,
>({
  settings,
  initialValue,
}: {
  settings: FinancialModelSettings[]
  initialValue?: T
}) {
  return settings.reduce(
    (acc, curr) => {
      let calculcatedStatus: FinancialModelCardLabel = `locked`
      if (curr.policy === `required`) {
        calculcatedStatus = curr.status
      } else if (curr.policy === `locked`) {
        calculcatedStatus = `locked`
      } else if (curr.policy === `optional`) {
        if (curr.status === `not_started`) {
          calculcatedStatus = `optional`
        } else {
          calculcatedStatus = curr.status
        }
      }

      return { ...acc, [curr.type]: calculcatedStatus }
    },
    initialValue ?? ({} as T)
  )
}
